export default "__VITE_ASSET__DVebXf$K__"